// src/Routes/Tools/config/toolsConfig.ts
import { ToolConfig } from "../../../Components/HighLevelComponents/Tool/types";
import quizConfig from "./quizConfig";
import mcqConfig from "./mcqConfig";
import flashcardConfig from "./flashcardConfig";

// Map of all tool configurations
const toolConfigs: Record<string, ToolConfig> = {
  quiz: quizConfig,
  mcq: mcqConfig,
  flashcards: flashcardConfig,
  // Add more tools here as needed
};

export default toolConfigs;

// For convenience, also export individual tools
export { quizConfig, mcqConfig, flashcardConfig };
